/**
 * Reserved-tag namespace. Tags under `sys:` are classifier tags the system
 * special-cases: they never appear as topic groups in the memory map and are
 * filtered out of the bind-time snapshot. The prefix is collision-proof — a
 * legitimate topic like `pref-shares` is never mistaken for the internal
 * `sys:pref` tag. Shared with the MOPS memory pane, which renders reserved
 * tags distinctly from topic tags.
 */
export const RESERVED_TAG_PREFIX = 'sys:';

/**
 * A durable preference about how the assistant should interact. Injected
 * verbatim at session start, most salient first up to a soft cap. The MOPS
 * memory pane groups rows carrying it into their own section.
 */
export const PREF_TAG = 'sys:pref';
